import { Button } from "@aidkitorg/component-library";
import { useLocalizedStrings } from "../../../Localization";
import { useConnectionModal } from "./ConnectionModalContext";
import { SourceHeader } from "./SourceHeader";
import { type ConnectionModalState } from "./types";

interface ConnectionModalSelectAccountPageProps {
  state: ConnectionModalState & { stage: "select_account" };
}

export function ConnectionModalSelectAccountPage({
  state,
}: ConnectionModalSelectAccountPageProps) {
  const L = useLocalizedStrings();
  const { getLocalizedString, onSelectAccount, onExit } = useConnectionModal();

  return <div>
    <SourceHeader source={state.selectedSource} />
    <p>{getLocalizedString("selectAccountText", "select_account_text")}</p>
    <div className="flex flex-col gap-3">
      {state.accountIds.map((accountId) => (
        <Button
          key={accountId}
          onClick={() => onSelectAccount(accountId)}
          dir="ltr" // This account id from Deck will always be in English
        >
          {accountId}
        </Button>
      ))}
    </div>
    <div className="mt-6 flex justify-between">
      <Button onClick={onExit} variant="secondary">
        {L.component_library.modal.close}
      </Button>
    </div>
  </div>
}
